let toutiaoList = {
  // 抑郁测试、情商测试、性格盲点、专业爱情、职业性格
    hotList:[
      {
        "introPicture": "https://imgco.xinli001.com/ceping/lingxi/scalePool/0c0c389890434d8b9019638541cbecf5.jpg",
        "name": "ABO性别测试",
        "scalePoolId": 591,
        "discountPrice": '19.9',
        "originalPrice": '19.9',
        "recommended": '4万',
      },
      {
        "introPicture": "https://imgco.xinli001.com/ceping/lingxi/scalePool/ad820d1d3b804bc892479250cdef12ee.png?x-oss-process=Q_80",
        "name": "情商测试",
        "scalePoolId": 153,
        "discountPrice": '19.9',
        "originalPrice": '19.9',
        "recommended": '8.1万',
      },
      {
        "introPicture": "https://imgco.xinli001.com/ceping/lingxi/scalePool/06d34ca00cb5434a95549c19970a2c3f.jpg?x-oss-process=Q_80",
        "name": "性格盲点测试",
        "scalePoolId": 440,
        "discountPrice": '19.9',
        "originalPrice": '19.9',
        "recommended": '5.1万',
      },
      {
        "introPicture": "https://imgco.xinli001.com/ceping/lingxi/scalePool/6ce9db35a17b41fe8713cb38e6c66363.png?x-oss-process=Q_80",
        "name": "专业爱情测试",
        "scalePoolId": 501,
        "discountPrice": '19.9',
        "originalPrice": '19.9',
        "recommended": '5.0万',
      },
      {
        "introPicture": "https://imgco.xinli001.com/ceping/lingxi/scalePool/090b3521e678443bbfaa65f62f8d15ec.png?x-oss-process=Q_80",
        "name": "职业性格测试",
        "scalePoolId": 75,
        "discountPrice": '19.9',
        "originalPrice": '19.9',
        "recommended": '4.8万',
      },
    ],
    kwaiHotList: [
      {
        "introPicture": "https://imgco.xinli001.com/ceping/lingxi/scalePool/c05197dca72b417a91043cba1c76573f.png?x-oss-process=Q_80",
        "name": "抑郁测试",
        "scalePoolId": 353,
        "discountPrice": '19.9',
        "originalPrice": '19.9',
        "recommended": '5.1万',
      },
      {
        "introPicture": "https://imgco.xinli001.com/ceping/lingxi/scalePool/ad820d1d3b804bc892479250cdef12ee.png?x-oss-process=Q_80",
        "name": "情商测试",
        "scalePoolId": 153,
        "discountPrice": '19.9',
        "originalPrice": '19.9',
        "recommended": '8.1万',
      },
      {
        "introPicture": "https://imgco.xinli001.com/ceping/lingxi/scalePool/6ce9db35a17b41fe8713cb38e6c66363.png?x-oss-process=Q_80",
        "name": "专业爱情测试",
        "scalePoolId": 501,
        "discountPrice": '19.9',
        "originalPrice": '19.9',
        "recommended": '5.0万',
      },
      {
        "introPicture": "https://imgco.xinli001.com/ceping/lingxi/scalePool/311b6c011cc24064a04bdbfcb88701f8.jpg?x-oss-process=Q_80",
        "name": "安全感测试",
        "scalePoolId": 640,
        "discountPrice": '19.9',
        "originalPrice": '19.9',
        "recommended": '4.8万',
      },
      {
        "introPicture": "https://imgco.xinli001.com/ceping/lingxi/scalePool/0c0c389890434d8b9019638541cbecf5.jpg",
        "name": "ABO性别测试",
        "scalePoolId": 591,
        "discountPrice": '19.9',
        "originalPrice": '19.9',
        "recommended": '4万',
      }
    ],
    
  	shareList:[
      {
        "title":"壹心理测评首页",
        "img": require('../../assets/toutiao/home.png'),
        "scalePoolId":"",
        "name":"首页",
        "recommended": '100万',
      },
      {
        "title":"人格原型测试",
        "img": "https://imgco.xinli001.com/ceping/lingxi/scalePool/241a1857748743d386f99970319819bc.png",
        "scalePoolId":549,
        "name":"人格原型测试",
        // "discountPrice": '19.9',
        "recommended": '5.1万',
      },
      {
        "title":"潜意识画像测试",
        "img": "https://imgco.xinli001.com/ceping/lingxi/scalePool/1d60f2b3a1d043899e5d09d53520abaf.png",
        "scalePoolId":541,
        "name":"潜意识画像测试",
        // "discountPrice": '19.9',
        "recommended": '3.4万',
      },{
        "title":"原生家庭伤痛评估",
        "img": "https://imgco.xinli001.com/ceping/lingxi/scalePool/8c86225799354e5189dcada11cdc538c.png",
        "scalePoolId":521,
        "name":"原生家庭伤痛评估",
        // "discountPrice": '19.9',
        "recommended": '3.8万',
      },
      {
        "title":"灵魂伴侣契合度评估",
        "img": "https://imgco.xinli001.com/ceping/lingxi/scalePool/caaa095e8c524ce7acd95af14448f6e2.jpg",
        "scalePoolId":366,
        "name":"灵魂伴侣契合度评估",
        // "discountPrice": '19.9',
        "recommended": '3.4万',
      },
  	]
}
export default toutiaoList


// WEBPACK FOOTER //
// ./src/pages/toutiaoApp/toutiaojson.js